import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_DETAILS_BY_PARAM, CANDIDATE_EDUCATION_PARAM, CANDIDATE_EDUCATIONS } from "../../../common/URLs";


// const AUTH = "Bearer 145|QMOEt4Ky7K3DGx6Hmc2Li8xlTXRR1Hq0EFntGyzK401f4f62";

export const fetchCandidateEducation = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_EDUCATION_PARAM}`; // Proxy path 
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    // console.log("response", data)
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addCandidateEducation = async ( newCandidateEducation) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_EDUCATIONS}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newCandidateEducation),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteCandidateEducation = async ( uuid) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_EDUCATIONS}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting job title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job title: " + error.message);
  }
};

export const updateCandidateEducation = async (uuid, CandidateEducationData) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_EDUCATIONS}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(CandidateEducationData),
    });
    // console.log("Data:", CandidateEducationData)

    if (!response.ok) {
      throw new Error("Error updating job : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job : " + error.message);
  }
};
